export const formatBooleanEvaluationValue = (
  value: unknown,
  labels: { yes: string; no: string; empty?: string }
): string => {
  const emptyLabel = labels.empty ?? '-'

  if (value === null || value === undefined) {
    return emptyLabel
  }

  const numericValue = Number(value)

  if (Number.isNaN(numericValue)) {
    return emptyLabel
  }

  if (numericValue === 0) {
    return labels.no
  }

  if (numericValue > 0) {
    return labels.yes
  }

  return emptyLabel
}

export const isBooleanEvaluationStep = (stepData: any): boolean => {
  if (!stepData) {
    return false
  }

  if (stepData.type?.component === 'Boolean') {
    return true
  }

  return stepData.sections?.some((section: any) =>
    section.fields?.some((field: any) => field.type === 'boolean')
  ) ?? false
}

const matchesCriterionId = (item: any, criterionId: string): boolean => {
  const itemId = item?.id || item?._id
  const itemFieldId = item?.fieldId || item?.criterionId

  return itemId === criterionId || itemFieldId === criterionId
}

export const getBooleanCriterionRawValue = (solution: any, criterionId: string): unknown => {
  if (!criterionId) {
    return null
  }

  const progressSections = solution?.progress?.sections

  if (Array.isArray(progressSections)) {
    for (const section of progressSections) {
      if (!Array.isArray(section.fields)) {
        continue
      }

      const field = section.fields.find((item: any) => matchesCriterionId(item, criterionId))

      if (field) {
        return field.points ?? field.value ?? null
      }
    }
  }

  const evaluations = solution?.evaluations || solution?.evaluation?.evaluations || []

  if (Array.isArray(evaluations)) {
    for (const evaluation of evaluations) {
      if (!Array.isArray(evaluation.answers)) {
        continue
      }

      const answer = evaluation.answers.find((item: any) => matchesCriterionId(item, criterionId))

      if (answer) {
        return answer.value ?? answer.points ?? null
      }
    }
  }

  return null
}
